import React from 'react';
import _ from 'lodash';
import r2wc from '@r2wc/react-to-web-component';
// @ts-ignore next
// import { CardContainer, CardContainerProps } from '@adc/ui-adc'
import CardContainer from '@adc/ui-core/components/elementals/cardContainer';
import { getWebComponentName } from '../utils';
import { useShadowStyles } from '../hooks/useShadowStyles';
const WrappedComponent = props => {
    const ref = useShadowStyles();
    const newProps = {
        ..._.omit(props, 'styleOverride'),
        style: props?.styleOverride, // eslint-disable-line
    };
    return (React.createElement("div", { ref: ref },
        React.createElement(CardContainer, { ...newProps },
            React.createElement("slot", null))));
};
const WebComponent = r2wc(WrappedComponent, {
    props: {
        styleOverride: 'json',
        padding: 'string',
        borderColor: 'string',
        borderStyle: 'string',
        borderRadius: 'string',
        borderRadiusCorners: 'string',
        backgroundColor: 'string',
        dropShadow: 'string',
    },
    shadow: 'open',
});
customElements.define(getWebComponentName('card'), WebComponent);
